import {ColorVariant} from '@gwc/core'
import {Button, Typography} from '@logistics-frontend/blocks'
import {MobileDrawer} from '@logistics-frontend/blocks/drawer'
import {useState} from 'react'

import {type ActionOpenRover} from 'src/api'
import {tagToUrl} from 'src/shared/utils'

import {useOpenRover} from './OpenRover.hook'
import * as classes from './OpenRoverButton.classes'

type Props = {
  action: ActionOpenRover
}

const COLOR_MAP: Record<string, ColorVariant> = {
  textMain: 'main',
  textMinor: 'minor',
}

export function OpenRoverButton(props: Props) {
  const {action} = props
  const {confirmation_modal: confirmationModal} = action

  const [opened, setOpened] = useState<boolean>(false)
  const openHandler = () => setOpened(true)
  const closeHandler = () => setOpened(false)

  const {isPending, openRoverHandler} = useOpenRover(props.action)

  const openRover = () => {
    openRoverHandler(closeHandler)
  }

  return (
    <>
      <div className={classes.mainButtonContainer}>
        <Button className={classes.mainButton} loading={isPending} onPress={openHandler} size="l" variant="action">
          {action.title || 'Открыть замок'}
        </Button>
      </div>
      <div
        // новый дровер плохо работает со старым. чтобы не было ложных скабатований скроле на основном дровере это костыль
        onTouchEnd={e => e.stopPropagation()}
        onTouchMove={e => e.stopPropagation()}
        onTouchStart={e => e.stopPropagation()}
      >
        <MobileDrawer.Base
          className={classes.root}
          classNameOverlay={classes.zIndexDraver}
          onClose={closeHandler}
          opened={opened}
        >
          <div className={classes.modalHead}>
            <div className={classes.imgContainer}>
              <img
                alt={`rover modal ${confirmationModal.header_image_tag}`}
                className={classes.img}
                src={tagToUrl(confirmationModal.header_image_tag)}
              />
            </div>
            <div className={classes.titleContainer}>
              {confirmationModal.title.items.map(
                (item, index) =>
                  item.type === 'text' && (
                    <Typography
                      key={`text-title-${index}`}
                      color={COLOR_MAP[item.color]}
                      group="normal"
                      style={{fontSize: item.font_size}}
                      thickness={item.font_weight}
                      variant="title4"
                    >
                      {item.text}
                    </Typography>
                  ),
              )}
            </div>
          </div>
          {confirmationModal.body && (
            <div className={classes.bodyContainer}>
              {confirmationModal.body.items.map(
                (item, index) =>
                  item.type === 'text' && (
                    <Typography
                      key={`text-body-${index}`}
                      className={classes.bodyText}
                      color={COLOR_MAP[item.color]}
                      group="normal"
                      style={{fontSize: item.font_size}}
                      thickness={item.font_weight}
                      variant="body2"
                    >
                      {item.text}
                    </Typography>
                  ),
              )}
            </div>
          )}
          <div className={classes.controlContainer}>
            <div className={classes.controlButtonContainer}>
              <Button
                alignItems="center"
                className={classes.controlButton}
                justifyContent="center"
                onPress={closeHandler}
                size="l"
              >
                {confirmationModal.close_button.title.items.map(
                  (item, index) =>
                    item.type === 'text' && (
                      <Typography
                        key={`text-button-${index}`}
                        className={classes.bodyText}
                        color={COLOR_MAP[item.color]}
                        group="normal"
                        style={{fontSize: item.font_size}}
                        thickness={item.font_weight}
                        variant="body2"
                      >
                        {item.text}
                      </Typography>
                    ),
                )}
              </Button>
            </div>
            <div className={classes.controlButtonContainer}>
              <Button
                className={classes.controlButton}
                Component="button"
                justifyContent="center"
                onPress={openRover}
                size="l"
                variant="action"
              >
                {confirmationModal.confirm_button.title.items.map(
                  (item, index) =>
                    item.type === 'text' && (
                      <Typography
                        key={`text-button-${index}`}
                        className={classes.bodyText}
                        color={COLOR_MAP[item.color]}
                        group="normal"
                        style={{fontSize: item.font_size}}
                        thickness={item.font_weight}
                        variant="body2"
                      >
                        {item.text}
                      </Typography>
                    ),
                )}
              </Button>
            </div>
          </div>
        </MobileDrawer.Base>
      </div>
    </>
  )
}
